import { render, staticRenderFns } from "./MasterDataWorkPage.vue?vue&type=template&id=1a1acae8&scoped=true&lang=pug&"
import script from "./MasterDataWorkPage.vue?vue&type=script&lang=ts&"
export * from "./MasterDataWorkPage.vue?vue&type=script&lang=ts&"
import style0 from "./MasterDataWorkPage.vue?vue&type=style&index=0&id=1a1acae8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1acae8",
  null
  
)

export default component.exports